import React, { useEffect } from "react";
import AllRouter from "./router/AllRouter";
import ScrollToTop from "./components/ScrollToTop";
import AOS from "aos";
import "aos/dist/aos.css";
import "photoswipe/dist/photoswipe.css";
import CookieConsentModal from "./components/cookies/CookieConsentModal";
import FacebookPixelWrapper from "./components/cookies/FacebookPixelWrapper";
import GoogleAnalyticsWrapper from "./components/cookies/GoogleAnalyticsWrapper";


const App = () => {
  useEffect(() => {
    AOS.init();
    document.body.classList.add("loaded");
  }, []);
  return (
    <div className="shane_tm_all_wrap">
      <FacebookPixelWrapper pixelId={process.env.REACT_APP_PIXEL_ID} />
      <GoogleAnalyticsWrapper gaId={process.env.REACT_APP_GA_ID} />
      <ScrollToTop />
      <AllRouter />
      <CookieConsentModal />
    </div>
  );
};

export default App;
